export const intro = `<div class="row">
    <div class="col auto"></div>
    <div class="col auto"></div>
    <div class="col auto"></div>
    <div class="col auto"></div>
</div>`

export const sizes = `<div class="column gap-10 primary">
    <div class="col I text-center p-2">1 unit</div>
    <div class="col II text-center p-2">2 unit</div>
    <div class="col III text-center p-2">3 unit</div>
    <div class="col IV text-center p-2">4 unit</div>
    <div class="col V text-center p-2">5 unit</div>
    <div class="col VI text-center p-2">6 unit</div>
</div>`

export const breakpointCol = `<div class="row">
    <div class="col I">1 of 6</div>
    <div class="col I">2 of 6</div>
    <div class="col I">3 of 6</div>
    <div class="col I">4 of 6</div>
    <div class="col I">5 of 6</div>
    <div class="col I">6 of 6</div>
</div>`

export const breakpointColSm = `<div class="row">
    <div class="col sm-I">1 of 6</div>
    <div class="col sm-I">2 of 6</div>
    <div class="col sm-I">3 of 6</div>
    <div class="col sm-I">4 of 6</div>
    <div class="col sm-I">5 of 6</div>
    <div class="col sm-I">6 of 6</div>
</div>`

export const breakpointMd = `<div class="row">
    <div class="col md-I">1 of 6</div>
    <div class="col md-I">2 of 6</div>
    <div class="col md-I">3 of 6</div>
    <div class="col md-I">4 of 6</div>
    <div class="col md-I">5 of 6</div>
    <div class="col md-I">6 of 6</div>
</div>`

export const breakpointLg = `<div class="row">
    <div class="col lg-I">1 of 6</div>
    <div class="col lg-I">2 of 6</div>
    <div class="col lg-I">3 of 6</div>
    <div class="col lg-I">4 of 6</div>
    <div class="col lg-I">5 of 6</div>
    <div class="col lg-I">6 of 6</div>
</div>`

export const breakpointXl = `<div class="row">
    <div class="col xl-I">1 of 6</div>
    <div class="col xl-I">2 of 6</div>
    <div class="col xl-I">3 of 6</div>
    <div class="col xl-I">4 of 6</div>
    <div class="col xl-I">5 of 6</div>
    <div class="col xl-I">6 of 6</div>
</div>`

export const column = `<div class="column">
    <div class="col III">col</div>
    <div class="col III">col</div>
    <div class="col III">col</div>
</div>`

export const rowColBg = `<div class="row dark">
    <div class="col auto">col</div>
    <div class="col auto">col</div>
    <div class="col auto">col</div>
</div>`

export const columnColBg = `<div class="column dark">
    <div class="col III">col</div>
    <div class="col III">col</div>
    <div class="col III">col</div>
</div>`